

export const AppText = {
  Adults: 'adults',
  Age: 'age',
  AgeDescription: 'ageDescription',
  AgentContactLabel: 'agentContactLabel',
  All: 'all',
  Arrival: 'arrival',
  BrowserWarningHeader: 'browserWarningHeader',
  BrowserWarningDescription: 'browserWarningDescription',
  BrowserWarningButtonText: 'browserWarningButtonText',
  Cabin: 'cabin',
  CustomerCategoriesValidation: 'customerCategoriesValidation',
  CabinDescription: 'cabinDescription',
  CabinDistributionButtonText: 'cabinDistributionButtonText',
  CabinDistributionDone: 'cabinDistributionDone',
  CabinDistributionEmptyCabin: 'cabinDistributionEmptyCabin',
  CabinInstructionList: 'cabinInstructionList',
  CabinsAllocatedInfo: 'cabinsAllocatedInfo',
  CheckInStartedInfo: 'checkInStartedInfo',
  Children: 'children',
  CompanyReference: 'companyReference',
  DateOfBirth: 'dateOfBirth',
  DateOfBirthDescription: 'dateOfBirthDescription',
  Day: 'day',
  Departure: 'departure',
  DocumentTypeLabel: 'documentTypeLabel',
  DocumentTypePlaceholder: 'documentTypePlaceholder',
  DocumentNumberLabel: 'documentNumberLabel',
  DocumentNumberPlaceholder: 'documentNumberPlaceholder',
  DocumentIssuingCountry: 'documentIssuingCountry',
  DocumentIssuingCountryPlaceholder: 'documentIssuingCountryPlaceholder',
  DocumentExpiryDate: 'documentExpiryDate',
  DocumentExpiryDatePlaceholder: 'documentExpiryDatePlaceholder',
  DropdownClearValueDescription: 'dropdownClearValueDescription',
  DropdownFilterNoResults: 'dropdownFilterNoResults',
  EmailLabel: 'emailLabel',
  EmailPlaceholder: 'emailPlaceholder',
  Errors: 'errors',
  ExpandAllDescription: 'expandAllDescription',
  ExtraLabel: 'extraLabel',
  ExtraPlaceholder: 'extraPlaceholder',
  FilterNoCabinDescription: 'filterNoCabinDescription',
  FilterNoCabinTitle: 'filterNoCabinTitle',
  FilterTabAvailableCabins: 'filterTabAvailableCabins',
  FilterTabFullCabins: 'filterTabFullCabins',
  FirstName: 'firstName',
  FirstNameDescription: 'firstNameDescription',
  Gender: 'gender',
  GenderDescription: 'genderDescription',
  GuestListSaved: 'guestListSaved',
  GuestNeedVisa: 'guestNeedVisa',
  Guests: 'guests',
  GuestLabel: 'guestLabel',
  HideGuest: 'hideGuest',
  IcePhoneNumberLabel: 'icePhoneNumberLabel',
  IcePhoneNumberPlaceholder: 'icePhoneNumberPlaceholder',
  Infants: 'infants',
  ImportFileBackButton: 'importFileBackButton',
  ImportFileChooseColumnPlaceholder: 'importFileChooseColumnPlaceholder',
  ImportFileDoneGuestToImportText: 'importFileDoneGuestToImportText',
  ImportFileDoneGuestsText: 'importFileDoneGuestsText',
  ImportFileDoneCabinOutText: 'importFileDoneCabinOutText',
  ImportFileDoneCabinHomeText: 'importFileDoneCabinHomeText',
  ImportFileDoneGuestTotalText: 'importFileDoneGuestTotalText',
  ImportFileDoneButton: 'importFileDoneButton',
  ImportFileNextButton: 'importFileNextButton',
  ImportFileRemoveButton: 'importFileRemoveButton',
  ImportFileUploadButton: 'importFileUploadButton',
  ImportFileUploadFileExplanationText: 'importFileUploadFileExplanationText',
  ImportFileUploadFileTitle: 'importFileUploadFileTitle',
  ImportFileShowModalButton: 'importFileShowModalButton',
  ImportFileStepProcessCabinText: 'importFileStepProcessCabinText',
  ImportFileStepProcessChooseColumnText: 'importFileStepProcessChooseColumnText',
  ImportFileStepProcessCompleteText: 'importFileStepProcessCompleteText',
  ImportFileStepProcessRemoveRowsText: 'importFileStepProcessRemoveRowsText',
  ImportFileStepProcessUploadFileText: 'importFileStepProcessUploadFileText',
  ImportFileUploadCompleteTitle: 'importFileUploadCompleteTitle',
  ImportFileUploadCompleteExplanationText: 'importFileUploadCompleteExplanationText',
  ImportFileRightClickMenuPaste: 'importFileRightClickMenuPaste',
  ImportFileCopyPasteTitle: 'importFileCopyPasteTitle',
  ImportFileCopyPasteExplanation: 'importFileCopyPasteExplanation',
  ImportFileCopyPastePlaceholder: 'importFileCopyPastePlaceholder',
  ImportFileHeaderTitle: 'importFileHeaderTitle',
  ImportFileChooseColumnTitle: 'importFileChooseColumnTitle',
  ImportFileChooseColumnExplanation: 'importFileChooseColumnExplanation',
  ImportFileRemoveDataTitle: 'importFileRemoveDataTitle',
  ImportFileRemoveDataExplanation: 'importFileRemoveDataExplanation',
  ImportFileRemoveDataTextRemoveRow: 'importFileRemoveDataTextRemoveRow',
  ImportFileDoneImportText: 'importFileDoneImportText',
  ImportFileNotStenaTemplateTitle: 'importFileNotStenaTemplateTitle',
  ImportFileNotStenaTemplateExplanation: 'importFileNotStenaTemplateExplanation',
  ImportFileNotStenaTemplateUploadNewFileTitle: 'importFileNotStenaTemplateUploadNewFileTitle',
  ImportFileNotStenaTemplateContinueText: 'importFileNotStenaTemplateContinueText',
  ImportFileDownloadTemplateTitle: 'importFileDownloadTemplateTitle',
  ImportFileMoreRowsThanGuestsTitle: 'importFileMoreRowsThanGuestsTitle',
  ImportFileMoreRowsThanGuestsInImportedFile: 'importFileMoreRowsThanGuestsInImportedFile',
  ImportFileMoreRowsThanGuestsInReservation: 'importFileMoreRowsThanGuestsInReservation',
  IncompletePassportFieldsText: 'incompletePassportFieldsText',
  LastName: 'lastName',
  LastNameDescription: 'lastNameDescription',
  MarketHelpDeskEmail: 'marketHelpDeskEmail',
  MarketHelpDeskPhoneNumber: 'marketHelpDeskPhoneNumber',
  MarketHelpDeskLink: 'marketHelpDeskLink',
  MarketHelpDeskLinkText: 'marketHelpDeskLinkText',
  MainHeading: 'mainHeading',
  ManageCabinsFor: 'manageCabinsFor',
  ManageCabinsListOfGuests: 'manageCabinsListOfGuests',
  ManageCabinsNoCabinSelectedText: 'manageCabinsNoCabinSelectedText',
  Missing: 'missing',
  Month: 'month',
  More: 'more',
  MultipleBedsLeft: 'multipleBedsLeft',
  Nationality: 'nationality',
  NationalityDescription: 'nationalityDescription',
  NoCabinSelected: 'noCabinSelected',
  NoGuestsInCabin: 'noGuestsInCabin',
  NoTrailer: 'noTrailer',
  OneBedLeft: 'oneBedLeft',
  PayingCustomer: 'payingCustomer',
  RegistrationNumber: 'registrationNumber',
  RegistrationNumberPlaceholder: 'registrationNumberPlaceholder',
  RemoveGuestTitle: 'removeGuestTitle',
  ReservationCode: 'reservationCode',
  ReservationFailedToLoad: 'reservationFailedToLoad',
  Saved: 'saved',
  SaveFailed: 'saveFailed',
  SavePending: 'savePending',
  SearchGuest: 'searchGuest',
  SearchGuestPlaceholder: 'searchGuestPlaceholder',
  SelectCabinInfoCompleteDescription: 'selectCabinInfoCompleteDescription',
  SelectCabinInfoEmptyDescription: 'selectCabinInfoEmptyDescription',
  SelectCabinInfoErrorDescription: 'selectCabinInfoErrorDescription',
  SelectCabinInfoHeading: 'selectCabinInfoHeading',
  SelectCabinInfoParagraph: 'selectCabinInfoParagraph',
  SelectCabinInfoSelectCabin: 'selectCabinInfoSelectCabin',
  SelectCabinInfoStartedDescription: 'selectCabinInfoStartedDescription',
  Seniors: 'seniors',
  ShowOnlyAge: 'showOnlyAge',
  SpecialNeed: 'specialNeeds',
  SpecialNeedPlaceholder: 'specialNeedPlaceholder',
  Students: 'students',
  Trailer: 'trailer',
  TrailerRegistrationNumber: 'trailerRegistrationNumber',
  ValidationReminder: 'validationReminder',
  VehiclesHeading: 'vehiclesHeading',
  VehicleType: 'vehicleType',
  VisaExplaination: 'visaExplaination',
  Warnings: 'warnings',
  WrongFormat: 'wrongFormat',
  Year: 'year',
};



// WEBPACK FOOTER //
// ./src/domain/appText.js